<template>
    <div class="companyList">
        <div class="companyListSide">
            <company-list-fliter></company-list-fliter>
        </div>
        <div class="companylistinfo" style="position: relative">
            <div class="companyListInfoHead">
                <div class="companyListInput">
                    <el-input v-model="keyword" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="companySearch" @input="companySearch"></el-input>
                </div>
                <!-- <div class="companyAdvancedSearch">
                     <img src="../../../assets/images/header/u210.png" class="searchImg">
                     <span style="font-size: 14px">高级检索</span>
                 </div>
                 <div class="companyBatchProcess">
                     <img src="../../../assets/images/header/u207.png" class="bacthImg">
                     <span style="font-size: 14px">批量处理</span>

                 </div>-->

                <div class="companyListShare"
                >
                <span  @click="shareClick"
                       v-clipboard:copy="copyUrl"
                       v-clipboard:success="onCopy">
                     <i class="arsenal_icon arsenalfenxiang"></i>
                     <span style="font-size: 14px">分享</span>
                </span>

                </div>
                <!-- <div class="companyListRefresh" @click="refreshClick">
                     <i class="el-icon-refresh-right" style="font-size: 20px" >
                     </i>
                     <span>刷新</span>
                 </div>-->
                <div class="companyBtn">
                    <!--<el-button type="primary" size="normal" @click="dialogVisible2=true" class="companyBatchBtn" style="font-size: 14px">批量导入</el-button>
                    <el-dialog
                            title="批量上传意图"
                            :visible.sync="dialogVisible2"
                            custom-class="moreInDialog"
                            style="text-align: left"
                    >
                        <div class="explain">
                            <span>说明：导入Excel表格行数上限为10000行，文件大小上限为2Mb。</span>
                        </div>
                        <div class="moreInText">
                            <div class="moreInTextItem">1.根据模板要求填写模板文件</div>
                            <div class="moreInTextItem">2.如果知识库中知识点的标准问与导入知识点完全匹配，导入的知识点
                                将被忽略。</div>
                            <div class="moreInTextItem">3.选择文件，开始导入</div>
                        </div>
                        <div class="editUpload">
                            <el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    multiple
                                    :limit="3"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                <div class="selectFileBtn">选择文件</div>
                            </el-upload>
                        </div>
                        <div class="noTemplate">
                            还没有模板？点击下载<span>《意图批量上传模板》</span>
                        </div>
                        <span slot="footer" class="dialog-footer">
                                <el-button @click="dialogVisible2 = false">取 消</el-button>
                                <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
                            </span>
                    </el-dialog>-->
                    <el-button type="primary" size="normal" @click="openAddCompany" style="font-size: 14px">新增公司</el-button>

                </div>
            </div>
            <div class="companyListInfoContain">
                <!--   <el-dialog title="表头设置" :visible.sync="dialogFormVisible" custom-class="sidebarDialog" style="text-align: left;" :close-on-click-modal="false">
                       <div class="sideFilterContain">
                           <div class="sideFilterNotShow">
                               <div style="font-weight: 600;font-size: 14px">未显示</div>
                               <div class="notShowCon" >
                                   <el-scrollbar>
                                       <div style="width: 100%;height: 400px" id="workOrderNotShowFilter">
                                           <div class="notShowAddTime"
                                           >
                                           </div>
                                       </div>
                                   </el-scrollbar>

                               </div>
                           </div>
                           <div class="sideFilterShow">
                               <div style="font-weight: 600;font-size: 14px">已显示</div>
                               <div class="showCon">
                                   <el-scrollbar style="height: 100%">
                                       <div style="width: 100%;height: 400px">
                                           <div class="showCompanyName">
                                               <span>全部工单</span>
                                           </div>
                                           <div id="workOrderFilter">
                                               <div class="allWorkOrderList"
                                               >
                                                   <div class="allWorkOrderListName">
                                                       {{}}
                                                   </div>
                                                   <div style="cursor: move" class="handle">
                                                       <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px" >
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </el-scrollbar>

                               </div>
                           </div>
                       </div>
                       <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogFormVisible = false">取 消</el-button>
                           <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
                       </div>
                   </el-dialog>
   -->
                <div>
                    <company-list-info-item
                            :companyList="clientCompany.list"
                            @modifyClientCompanyClick="modifyClientCompanyClick"
                            @deleteClientCompanyInfo="deleteClientCompanyInfo"
                            @handleSelectionChange="handleSelectionChange"
                    />
                </div>
                <div style="position: absolute;left:24px;bottom: 0;line-height: 70px" v-if="companyCheckNum.length > 0">
                    <span style="font-size: 13px">共选中<span style="padding: 0 5px">{{companyCheckNum.length}}</span>个公司</span>
                </div>
                <div style="position: absolute;bottom: 20px;right: 56px;">
                    <el-pagination
                            :page-size="pageSize"
                            :current-page.sync="currentPage"
                            @current-change="getClientCompanyList"
                            :total="clientCompany.total"
                            background
                            :page-sizes="[10, 20, 30, 40]"
                            @size-change="handleSizeChange"
                            layout="total, sizes, prev, pager, next, jumper"
                            style="height: 40px;line-height: 40px;text-align: right"
                    >
                    </el-pagination>
                </div>
            </div>

        </div>
      <el-dialog title="新增公司"  :visible.sync="dialogFormVisible1" custom-class="customerListDialog" style="text-align: left;" :close-on-click-modal="false">
        <el-form :label-position="labelPosition" >
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1"><span class="keyred">*</span>公司名称</div>
            <div class=" companyFlexClass2">
              <el-input
                  placeholder="请输入公司名称"
                  v-model="companyName"
                  clearable
              >
              </el-input>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">
              等级
            </div>
            <div class=" companyFlexClass2">
              <el-radio v-model="levelRadio" label="NORMAL" style="margin-right:8px">普通</el-radio>
              <el-radio v-model="levelRadio" label="VIP">vip</el-radio>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">公司邮箱后缀
              <el-popover
                  placement="top-start"
                  width="230"
                  trigger="hover"
              >
                <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

                <span slot="reference" style="margin-left: 4px;height: 20px;text-align: center">
                                        <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
              </el-popover>

            </div>
            <div class=" companyFlexClass2" >
              <el-input
                  placeholder="请输入公司邮箱后缀"
                  v-model="emailSuffix"
                  clearable
              >
              </el-input>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">公司联系人</div>
            <div class=" companyFlexClass2" >
              <el-input
                  placeholder="请输入公司联系人姓名"
                  v-model="contactPerson"
                  clearable
              >
              </el-input>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">联系人电话</div>
            <div class=" companyFlexClass2" >
              <el-input
                  placeholder="请输入公司联系人电话"
                  v-model="contactPersonTel"
                  clearable
                  @blur="phoneBlurClick"
              >
              </el-input>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class="companyFlexClass1">联系人邮箱</div>
            <div class=" companyFlexClass2" >

              <el-input
                  placeholder="请输入联系人邮箱"
                  v-model="contactPersonMail"
                  clearable
                  @blur="emaiBblurClick"
              >
              </el-input>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">负责组</div>
            <div class=" companyFlexClass2" >
              <el-select v-model="groupValue"
                         clearable
                         placeholder="请选择或者搜索负责组"
                         style="width: 100%;position: relative"
                         @change="getAccountPerson"
              >
                <div style="margin: 5px 0">
                  <el-input
                      placeholder="可搜索"
                      v-model="groupSelect"
                      clearable
                      style="position: absolute;top: 0;z-index: 9"
                      @input="changeSelectGroup"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <div v-if="selectGroupList.length===0">
                  <el-option value="" style="height: 5px"></el-option>
                </div>
                <div style="margin-top: 32px">
                  <el-option
                      v-for="item in selectGroupList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                  </el-option>
                </div>


              </el-select>
            </div>
          </div>
          <div class=" companyFlexClass">
            <div class=" companyFlexClass1">负责人</div>
            <div class=" companyFlexClass2" >
              <el-select v-model="personValue"
                         clearable
                         placeholder="请选择或者搜索负责人"
                         style="width: 100%;position: relative"
              >
                <div style="margin: 5px 0">
                  <el-input
                      placeholder="可搜索"
                      v-model="personSelect"
                      clearable
                      style="position: absolute;top: 0;z-index: 9"
                      @input="changeSelectPerson"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <div v-if="selectPersonList.length===0">
                  <el-option value="" style="height: 5px;"></el-option>
                </div>
                <div style="margin-top: 32px">
                  <el-option
                      v-for="item in selectPersonList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </div>

              </el-select>
            </div>
          </div>
          <div style="display: flex;padding: 6px 0 0 0">
            <div style="flex: 0.2 0.2 0 ;height: 40px;line-height: 40px;">描述</div>
            <div style="flex: 0.8 0.8 0">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="对该公司的描述"
                  v-model="description">
              </el-input>
            </div>
          </div>
        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="addClientCompany">保存</el-button>
          <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
        </div>
      </el-dialog>
    </div>

</template>

<script>
    import CompanyListInfoItem from "./CompanyListInfoItem";
    import CompanyListFliter from "../companylistfilter/CompanyListFliter";
    export default {
        name: "CompanyListInfo",
        components:{CompanyListFliter, CompanyListInfoItem},
        data(){
            return{
                checked:false,
                keyword:'',
                levelRadio:'NORMAL',
                dialogVisible2:false,
                dialogFormVisible1:false,
                pageSize:20,
                currentPage:1,
                clientCompany:{
                    list:[],
                    total:0
                },
                companyName:'',
                emailSuffix:'',
                contactPerson:'',
                contactPersonMail:'',
                contactPersonTel:'',
                description:'',
                companyNum:0,
                groupValue:'',
                groupSelect:'',
                groups:[],
                personValue:'',
                personSelect:'',
                persons:[],
                fileList:[],
                accountGroup:{
                    list:[]
                },
                accountPerson:{
                    list:[]
                },
                grade:'',
                isCheck:false,
                copyUrl:'',
                fromValue:{
                    contactPersonMail:''
                },
                selectGroupList:[],
                selectPersonList:[],
                companyCheckList:[],
                copyUrl1:'',
                companyCheckNum:'',
                labelPosition:'left'

            }
        },

        mounted() {
            this.$nextTick(() => {
                this.getClientCompanyList();
                this.getAccountGroup();
                this.getAccountPerson();
            });
        },
        filters:{
            gradeType(value){
                if(value==='NORMAL')
                    return '普通'
                if(value==='VIP')
                    return 'VIP'
            }
        },
        methods:{
            companySearch (){
                this.currentPage=1
                this.getCompanyList()
            },
            getCompanyList(){
                let filterId = this.$route.query.id;
                let searchParam={
                    type:'COMPANY',
                    page:this.currentPage,
                    size:this.pageSize,
                    keyword:this.keyword
                }
                if(filterId){
                    searchParam.filterId = filterId;
                }
                console.log("search param:",searchParam);
                this.$http.get('/api/search',{params:searchParam})
                    .then(response => {
                        this.clientCompany.list = response.data.data.content;
                        this.clientCompany.total=response.data.data.totalElements
                        this.$emit('companySearch',this.clientCompany.total)
                        console.debug('FieldApiExample field page:', this.clientCompany);
                    })
            },
            searchCompny(){
                let filterId = this.$route.query.id;
                if(this.keyword==='')
                {
                    let searchParam={
                        type:'COMPANY',
                        page:this.currentPage,
                        size:this.pageSize,
                    }
                    if(filterId){
                        searchParam.filterId = filterId;
                    }
                    console.log("search param:",searchParam);
                    this.$http.get('/api/search',{params:searchParam})
                        .then(response => {
                            this.clientCompany.list = response.data.data.content;
                            this.clientCompany.total=response.data.data.totalElements
                            this.$emit('searchCompny',this.clientCompany.total)
                            console.debug('FieldApiExample field page:', this.clientCompany);
                        })
                }
            },
            refreshClick(){
                this.$router.go(0)
            },
            //获取公司列表的信息
            getClientCompanyList() {
                this.getCompanyList()
            },
            //新增公司
            addClientCompany(){
                if(this.companyName==='')
                    this.$message('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {
                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.groupValue,
                        name: this.companyName,
                        principalId: this.personValue,
                        grade: this.levelRadio,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompanyList()


                    });
                    this.dialogFormVisible1=false

                }
                this.$emit('addClientCompany')

            },
            openAddCompany(){
                this.contactPerson=''
                this.contactPersonMail=''
                this.contactPersonTel=''
                this.description=''
                this.groupValue=''
                this.companyName=''
                this.personValue=''
                this.emailSuffix=''
                this.levelRadio='NORMAL'
                this.dialogFormVisible1=true
            },
            addCompanyContinue(){
                if(this.companyName==='')
                    this.$message('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {
                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.groupValue,
                        name: this.companyName,
                        principalId: this.personValue,
                        grade: this.levelRadio,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.$emit('addCompanyContinue')
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getClientCompanyList()
                    });
                    this.openAddCompany()
                }

                    /*   console.debug('post field response:', res);*/

            },
            //获取负责组下拉列表值
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.selectGroupList=res.data.data
                    console.log(res.data.data)
                })
            },
            //获取负责人的下拉列表值
            getAccountPerson(){
                if(this.groupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.groupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                    })
                }
                if(this.groupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        console.log(this.selectPersonList)
                    })
                }


            },
            modifyClientCompanyClick(){
                this.$emit('modifyClientCompanyClick')
                this.getClientCompanyList()

            },
            deleteClientCompanyInfo(){
                this.$emit('deleteClientCompanyInfo',this.pageSize,this.currentPage)
                this.getClientCompanyList()
            },
            handleSelectionChange(value){
                this.companyCheckNum=value
                this.companyCheckList=value
            },
            handleSizeChange(value){
                this.pageSize=value
                this.getClientCompanyList()
            },
            handleCurrentChange(value){
                this.currentPage=value
                this.getClientCompanyList()
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },

            shareClick(){

                if(this.companyCheckList.length===0)
                {
                    this.$message({
                        message:'请选择要分享的公司',
                        type:"error",
                        duration:800
                    })
                }
                else {
                    this.copyUrl=''
                    this.copyUrl1=''
                    for (let i =0;i<this.companyCheckList.length;i++)
                    {
                        if(this.companyCheckList[i]!==undefined)
                        {
                            let grade=''
                            if(this.companyCheckList[i].grade==='VIP')
                                grade='VIP'
                            if(this.companyCheckList[i].grade==='NORMAL')
                                grade='普通'
                            if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人:'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'负责组:'+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人:'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }


                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0\xa0'+grade+'\n'+'公司联系人'+'\xa0\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0\xa0'+this.companyCheckList[i].groupName+'负责人:'+'\xa0\xa0'+this.companyCheckList[i].principalName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }



                            else if(this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }

                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPerson!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'公司联系人:'+'\xa0'+this.companyCheckList[i].contactPerson+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }

                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }

                            else if(this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonTel!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].contactPersonMail!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].description!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+'\n'+'------------------------------------'+'\n'

                            }

                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonTel!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!==''&&this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'负责人:'+'\xa0'+this.companyCheckList[i].principalName+"\n"+'描述:'+'\xa0'+this.companyCheckList[i].description+'\n'+'------------------------------------'+'\n'

                            }


                            else if(this.companyCheckList[i].contactPersonMail!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人邮箱:'+'\xa0'+this.companyCheckList[i].contactPersonMail+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].contactPersonTel!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'联系人电话:'+'\xa0'+this.companyCheckList[i].contactPersonTel+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'描述:'+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].principalId!=='')
                            {
                                this.copyUrl1+='公司名称'+this.companyCheckList[i].name+'\n'+'等级:'+grade+'\n'+'负责组:'+this.companyCheckList[i].groupName+"\n"+'负责人:'+this.companyCheckList[i].principalName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].groupId!==''&&this.companyCheckList[i].principalId==='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+"负责组:"+'\xa0'+this.companyCheckList[i].groupName+"\n"+'------------------------------------'+'\n'

                            }
                            else if(this.companyCheckList[i].description!=='')
                            {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+"描述:"+'\xa0'+this.companyCheckList[i].description+"\n"+'------------------------------------'+'\n'

                            }
                            else {
                                this.copyUrl1+='公司名称:'+'\xa0'+this.companyCheckList[i].name+'\n'+'等级:'+'\xa0'+grade+'\n'+'------------------------------------'+"\n"

                            }

                        }

                    }
                    this.copyUrl='向您分享了公司'+'\n'+'\n'+this.copyUrl1
                }

               /* this.copyUrl=window.location.href
                console.log(window.location.href)*/
            },
            onCopy() {
                this.$message({
                    type:"success",
                    message:'分享成功',
                    duration:800
                })
            },
            emaiBblurClick(){

                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.contactPersonMail!=='')
                {
                    if(!reg.test(this.contactPersonMail))
                        this.$message('请输入有效的邮箱')
                }

            },
            phoneBlurClick(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.contactPersonTel!=='')
                {
                    if(!phone.test(this.contactPersonTel))
                        this.$message('请输入有效的电话号码')
                }

            },
            //获取受理组的搜索下拉
            changeSelectGroup(){
                if(this.groupSelect!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(this.groupSelect) || !!~item.name.toUpperCase().indexOf(this.groupSelect.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectGroupList=selectCompany

                }
                else
                {
                    this.selectGroupList=this.accountGroup.list
                }

            },

            //获取受理人的搜索下拉
            changeSelectPerson(){
                if(this.personSelect!=='')
                {
                    let selectPerson=[]
                    this.accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(this.personSelect) || !!~item.name.toUpperCase().indexOf(this.personSelect.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectPersonList=selectPerson

                }
                else
                {
                    this.selectPersonList=this.accountPerson.list
                }
            }
        },
        beforeRouteUpdate(to,from,next){
            next()
            this.getClientCompanyList()
        },
    }
</script>

<style scoped lang="less">
@import "../../../assets/less/customlist/companylistinfo/companylistinfo";
    .companyList{
        display: flex;
        flex-direction: row;
        .companyListSide{

            background-color: white;
            .customlistSidetTitle{
                height: 56px;
                line-height: 56px;
                font-size: 18px;
                text-align: center;
                border-bottom: 1px solid #dddddd;
            }
            .customlistSideHeader{
                height: 40px;
                line-height: 40px;
                text-align: center;
                // border-right: 1px solid #dddddd;
            }
        }
        .companylistinfo{
            flex: 1;
        }
    }
</style>